<script setup lang="ts">
import type { NovaIconProps } from './NovaIcon.types'

withDefaults(defineProps<NovaIconProps>(), {
  size: 20,
})
</script>

<template>
  <i
    :class="['icon', 'lmnova', icon.type, icon.name]"
    :style="{ fontSize: String(size) + 'px' }"
  />
</template>

<style lang="scss" scoped></style>
